import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-form-help',
  templateUrl: './form-help.component.html',
  styleUrls: ['./form-help.component.scss']
})
export class FormHelpComponent implements OnInit {

  @Input() html: string = undefined;
  @Input() class: any = 'icon-help pl-1';
  @Input() templateId: string = undefined;

  /**
   * 
   */
  constructor() { }

  /**
   * 
   */
  ngOnInit(): void {
  }

}
